import { actions } from '@/store/modules/time-tool/actions';
import { mutations } from '@/store/modules/time-tool/mutations';
const state = {
    active: false,
    startDate: new Date(),
};
export const TimeTool = {
    namespaced: true,
    state,
    mutations,
    // getters,
    actions,
};
